import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

const FilterStatus = props => (
    <div className="ui-filter__status">
        {(() => {
            let displayStatus = props.status.map((status) => {
                if (props.displayName) {
                    return props.displayName(status.parameter, status.option);
                }

                return status.options.displayName;
            });

            if (props.reverse) {
                displayStatus = displayStatus.reverse();
            }

            return displayStatus.join(props.separator);
        })()}
    </div>
);

FilterStatus.propTypes = {
    stateKey: PropTypes.string.isRequired,
    status: PropTypes.array.isRequired,
    displayName: PropTypes.func,
    reverse: PropTypes.bool,
    separator: PropTypes.string,
};

FilterStatus.defaultProps = {
    reverse: true,
    separator: ', '
};

function mapStateToProps(state, ownProps) {
    const stateProps = _.get(state, ownProps.stateKey).filter;
    return {
        status: stateProps.status
    };
}

export default connect(mapStateToProps)(FilterStatus);



// WEBPACK FOOTER //
// ./src/js/modules/Filter/components/FilterStatus.js